import MuiLink from "@mui/material/Link";
import Link from "next/link";
import { toUserError } from "@/framework/errors/toUserError";

// Code thrown by addPendingCreditTransaction when a debit would bring the
// balance below 0.
export const insufficientCreditsCode = "insufficient_credits";

export function isInsufficientCreditsError(error: unknown) {
  return toUserError(error).details.code === insufficientCreditsCode;
}

export const InsufficientCreditsMessage = () => (
  <>
    You&apos;re out of credits.{" "}
    {/* Inherit color: primary is unreadable on the dark tooltip background. */}
    <MuiLink
      component={Link}
      href="/account/topup"
      color="inherit"
      underline="always"
    >
      Top up your balance
    </MuiLink>{" "}
    to continue.
  </>
);
